import {
  GET_BOARD_FLOW_CHARTS,
  GET_FLOW_CHART_BY_ID,
  CREATE_FLOW_CHART,
  UPDATE_FLOW_CHART,
  SET_FLOW_CHART_ARCHIVE,
  DELETE_FLOW_CHART,
  CREATE_TASK_FLOW_CHART,
  CREATE_TASK_MAP_FLOW_CHART,
  UPDATE_TASK_FLOW_CHART,
  UPDATE_TASK_MAP_FLOW_CHART,
  DELETE_TASK_FLOW_CHART,
  DELETE_TASK_MAP_FLOW_CHART,
  SET_FLOW_CHARTS_LOADING,
  SET_FLOW_CHARTS_ERROR,
  CLEAR_FLOW_CHART_STATE,
  CLEAR_CURRENT_FLOW_CHART,
  GET_FLOW_CHART_CATEGORIES,
  SET_FLOW_CHART_CATEGORIES_LOADING,
  SET_FLOW_CHART_CATEGORIES_ERROR,
} from "./FlowChartType";

const INITIAL_STATE = {
  items: [],
  tasksItems: [],
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    pages: 0,
  },
  currentFlowChart: null,
  loading: false,
  error: null,
  categories: [],
  categoriesLoading: false,
  categoriesError: null,
};

const updateFlowChartInList = (items, updatedItem) => {
  const index = items.findIndex((item) => item._id === updatedItem._id);
  if (index === -1) return items;
  const next = [...items];
  next[index] = updatedItem;
  return next;
};

const removeFlowChartFromList = (items, flowChartId) =>
  items.filter((item) => item._id !== flowChartId);

export const FlowChartReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_FLOW_CHARTS_LOADING:
      return {
        ...state,
        loading: action.Payload,
      };

    case SET_FLOW_CHARTS_ERROR:
      return {
        ...state,
        error: action.Payload,
        loading: false,
      };

    case GET_BOARD_FLOW_CHARTS:
      return {
        ...state,
        items: action.Payload.items ?? state.items,
        tasksItems: action.Payload.tasksItems ?? state.tasksItems,
        pagination: action.Payload.pagination ?? state.pagination,
        error: null,
      };

    case CREATE_TASK_FLOW_CHART: {
      const { TaskID, items } = action.Payload || {};
      if (!items || !Array.isArray(items)) return state;
      const rest = (state.tasksItems || []).filter(
        (t) => t.TaskID !== TaskID || t.TaskMapID != null,
      );
      const withTaskId = items.map((i) => ({ ...i, TaskID }));
      return { ...state, tasksItems: [...rest, ...withTaskId], error: null };
    }
    case CREATE_TASK_MAP_FLOW_CHART: {
      const { TaskID, TaskMapID, items } = action.Payload || {};
      if (!items || !Array.isArray(items)) return state;
      const rest = (state.tasksItems || []).filter(
        (t) => t.TaskID !== TaskID || t.TaskMapID !== TaskMapID,
      );
      const withIds = items.map((i) => ({ ...i, TaskID, TaskMapID }));
      return { ...state, tasksItems: [...rest, ...withIds], error: null };
    }

    case UPDATE_TASK_FLOW_CHART:
    case UPDATE_TASK_MAP_FLOW_CHART: {
      const items = action.Payload?.items;
      const flowChartId = action.Payload?.FlowChartID;
      if (!items || !Array.isArray(state.tasksItems) || !flowChartId)
        return state;
      const updated = Array.isArray(items)
        ? items.find((x) => x._id === flowChartId)
        : null;
      const next = state.tasksItems.map((t) =>
        t._id === flowChartId ? { ...t, ...updated } : t,
      );
      return { ...state, tasksItems: next, error: null };
    }

    case DELETE_TASK_FLOW_CHART:
    case DELETE_TASK_MAP_FLOW_CHART:
      return {
        ...state,
        tasksItems: (state.tasksItems || []).filter(
          (t) => t._id !== action.Payload?.FlowChartID,
        ),
        error: null,
      };

    case GET_FLOW_CHART_BY_ID:
      return {
        ...state,
        currentFlowChart: action.Payload,
        error: null,
      };

    case CREATE_FLOW_CHART:
      return {
        ...state,
        items: [action.Payload, ...state.items],
        currentFlowChart: action.Payload,
        pagination: {
          ...state.pagination,
          total: state.pagination.total + 1,
        },
        error: null,
      };

    case UPDATE_FLOW_CHART:
      return {
        ...state,
        items: updateFlowChartInList(state.items, action.Payload),
        currentFlowChart:
          state.currentFlowChart?._id === action.Payload._id
            ? action.Payload
            : state.currentFlowChart,
        error: null,
      };

    case SET_FLOW_CHART_ARCHIVE:
      return {
        ...state,
        items: updateFlowChartInList(state.items, action.Payload),
        currentFlowChart:
          state.currentFlowChart?._id === action.Payload._id
            ? action.Payload
            : state.currentFlowChart,
        error: null,
      };

    case DELETE_FLOW_CHART:
      return {
        ...state,
        items: removeFlowChartFromList(state.items, action.Payload),
        currentFlowChart:
          state.currentFlowChart?._id === action.Payload
            ? null
            : state.currentFlowChart,
        pagination: {
          ...state.pagination,
          total: Math.max(0, state.pagination.total - 1),
        },
        error: null,
      };

    case CLEAR_FLOW_CHART_STATE:
      return INITIAL_STATE;

    case CLEAR_CURRENT_FLOW_CHART:
      return {
        ...state,
        currentFlowChart: null,
      };

    case SET_FLOW_CHART_CATEGORIES_LOADING:
      return {
        ...state,
        categoriesLoading: action.Payload,
      };

    case SET_FLOW_CHART_CATEGORIES_ERROR:
      return {
        ...state,
        categoriesError: action.Payload,
        categoriesLoading: false,
      };

    case GET_FLOW_CHART_CATEGORIES:
      return {
        ...state,
        categories: Array.isArray(action.Payload) ? action.Payload : [],
        categoriesError: null,
        categoriesLoading: false,
      };

    default:
      return state;
  }
};
